export interface UserState {
    access_token : string,
    token_type : string,
    expires_in : number,
    userName : string,
    '.issued' : string,
    '.expires' : string,
    roles : Array<string>,
    isAuthenticated : boolean,
    isAdmin : boolean,
    // Any others add here
    PortalSettings : {
        AllowedRoles : {
            [key : string] : Array<string>
        }
    },
    UserSettings : {
        HrReports? : any,
        Color? : string,
        TicketSearchColumns?: Array<string> | null,
    } | null,
    loginErrorOpen : boolean,
    loginErrorMessage : string,
    authModalOpen : boolean,
    loading : boolean,
    userId : string,
    homeProfitCenter: string | number
    // userAgentApplication : UserAgentApplication
}

export const LOGOUT = "LOGOUT";
export const LOGOUT_KEEP_DATA = "LOGOUT_KEEP_DATA";
export const LOGIN_AS_ADMIN = "LOGIN_AS_ADMIN";
export const LOGIN_WITH_USERNAME_PASSWORD = "LOGIN_WITH_USERNAME_PASSWORD";
export const LOGIN_WITH_USERNAME_PASSWORD_ERROR = "LOGIN_WITH_USERNAME_PASSWORD_ERROR";
export const SET_LOADING = "SET_LOADING";
export const TOGGLE_ADMIN = "TOGGLE_ADMIN";
export const UPDATE_USER_SETTINGS = "UPDATE_USER_SETTINGS";
export const TOGGLE_AUTH_MODAL = "TOGGLE_AUTH_MODAL";

//  NOTE : Update these types when model is fleshed out

export type ResponseData = {
    access_token : string,
    token_type : string,
    expires_in : number,
    userName : string,
    '.issued' : string,
    '.expires' : string,
    roles : string,
    userId : string,
    homeProfitCenter: string | number
}

export type LoginData = {
    access_token : string,
    token_type : string,
    expires_in : number,
    userName : string,
    '.issued' : string,
    '.expires' : string,
    roles : Array<string>,
    userId : string,
    homeProfitCenter: string | number
}

export type SettingsEndpointType = {
    PortalSettings : {
        allowedRoles : Array<string>
    };
    UserSettings? : null;
}

interface Logout {
    type : typeof LOGOUT;
}

interface loginAsAdmin{
    type : typeof LOGIN_AS_ADMIN;
    payload : LoginData;
}

interface setLoading{
    type : typeof SET_LOADING,
    payload : boolean,
}

type LoginWithUsernamePasswordType = {
    access_token : string,
    token_type : string,
    expires_in : number,
    userName : string,
    '.issued' : string,
    '.expires' : string,
    roles : Array<string>,
    isAdmin? : boolean,
    PortalSettings : {
        AllowedRoles : {
            [key : string] : Array<string>
        }
    },
    UserSettings : any,
    userId : string,
    homeProfitCenter: string | number
}

interface loginWithUsernamePassword{
    type : typeof LOGIN_WITH_USERNAME_PASSWORD,
    payload : LoginWithUsernamePasswordType
}

interface loginWithUsernamePasswordError{
    type : typeof LOGIN_WITH_USERNAME_PASSWORD_ERROR,
    payload : string,
}

interface ToggleAdmin{
    type : typeof TOGGLE_ADMIN,
}

interface updateUserSettings {
    type : typeof UPDATE_USER_SETTINGS,
    payload : any
}

interface toggleAuthModal {
    type: typeof TOGGLE_AUTH_MODAL;
    payload: boolean;
}

export type UserTypes = 
Logout 
| loginAsAdmin 
| loginWithUsernamePassword 
| loginWithUsernamePasswordError 
| setLoading 
| ToggleAdmin
| updateUserSettings
| toggleAuthModal;
